import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import HoverAccentButton from './HoverAccentButton';
import AccentButton from './AccentButton';
import BoxInput from '../Input/BoxInput';

class InputButton extends Component {
  state = {
    showButton: true
  };

  onButtonClick = (e) => {
    this.props.onButtonClick(e);
    this.setState({ showButton: false });
  };

  onInputKeyDown = (e) => {
    this.props.onInputKeyDown(e);
    if (e.keyCode === 13) {
      if (this.props.blurOnEnter) {
        this.onInputBlur(e);
      }
    }
  };

  onInputBlur = (e) => {
    this.props.onInputBlur(e);
    this.setState({ showButton: true });
  };

  render() {
    const disabledClass = classnames({
      'theme--disabled-opacity': this.props.disabled
    });
    if (this.state.showButton) {
      const { buttonProps, useHoverInput } = this.props;
      if (useHoverInput) {
        return <HoverAccentButton {...buttonProps} onClick={this.onButtonClick} />;
      }
      return <AccentButton {...buttonProps} onClick={this.onButtonClick} />;
    }

    const { inputProps, onInputChange } = this.props;
    return (
      <BoxInput
        {...inputProps}
        autofocus={true}
        onBlur={this.onInputBlur}
        onChange={onInputChange}
        onKeyDown={this.onInputKeyDown}
        className={disabledClass}
      />
    );
  }
}

InputButton.propTypes = {
  buttonProps: PropTypes.shape(AccentButton.propTypes).isRequired,
  inputProps: PropTypes.shape(BoxInput.propTypes).isRequired,
  onButtonClick: PropTypes.func,
  onInputBlur: PropTypes.func,
  onInputChange: PropTypes.func,
  onInputKeyDown: PropTypes.func,
  blurOnEnter: PropTypes.bool,
  useHoverInput: PropTypes.bool
};

InputButton.defaultProps = {
  onButtonClick: () => {},
  onInputBlur: () => {},
  onInputChange: () => {},
  onInputKeyDown: () => {},
  blurOnEnter: true,
  useHoverInput: false
};

export default InputButton;
